<span class="tags_tags" [class.tags_tags--disabled]="!showPopover">
  @if (attachments()?.length > 0) {
    <button
      aria-label="Attachments"
      data-userguide="chapter-icons_attachments"
      [ttTooltip]="'Attachments' | transloco"
      [ttTooltipDisabled]="!showPopover"
      (click)="openPopover($event, NodeDetailPopoverTab.ATTACHMENTS)">
      <mat-icon class="tags_tags-tag" [icon]="'paperclip'" [iconSize]="12" />
    </button>
  }

  @if (links()?.length > 0) {
    <button
      aria-label="Links"
      class="tags_tags-tag"
      data-userguide="element-icons_links"
      [ttTooltip]="'Links' | transloco"
      [ttTooltipDisabled]="!showPopover"
      (click)="openPopover($event, NodeDetailPopoverTab.LINKS)">
      <mat-icon [icon]="'new-tab'" [iconSize]="12" />
    </button>
  }

  @if (medicationRequests()?.length > 0) {
    <button
      aria-label="Medications"
      class="tags_tags-tag"
      data-userguide="chapter-icons_medications"
      [ttTooltip]="'Medications' | transloco"
      [ttTooltipDisabled]="!showPopover"
      (click)="openPopover($event, NodeDetailPopoverTab.MEDICATIONS)">
      <mat-icon [icon]="'medication'" [iconSize]="12" />
    </button>
  }

  @if (references()?.length > 0) {
    <button
      aria-label="References"
      class="tags_tags-tag"
      data-userguide="chapter-icons_references"
      [ttTooltip]="referencesText()"
      [ttTooltipDisabled]="!showPopover"
      (click)="openPopover($event, NodeDetailPopoverTab.REFERENCES)">
      <mat-icon [icon]="'book'" [iconSize]="12" />
    </button>
  }
</span>

@if (optional()) {
  <common-chip>
    {{ 'Optional' | transloco }}
  </common-chip>
}
